import React from 'react';
import Link from 'gatsby-link';
import { FormattedMessage } from 'react-intl';

import SelectLanguage from './SelectLanguage';

import "../styles/Header.scss";
import logo from "../assets/logo.png"; 

const Header = ({ langs }) => {

  const langToSelect = langs.filter(l => !l.selected)[0];
  const currentLangKey = langs.filter(l => l.selected)[0].langKey;

  return (
    <header className="navbar container grid-lg" id="header">
      <div className="navbar-center">
        <Link to="/" className="navbar-brand mr-2">
          <img src={logo} alt="ImmigrationInfo.org" />
        </Link>
      </div>
      <div className="navbar-div Header__links">
        <Link to={`/${currentLangKey}/about`} className={`btn btn-link`}>
          <FormattedMessage id="about" />
        </Link>
        <Link to={`/${currentLangKey}/glossary`} className={`btn btn-link`}>
          <FormattedMessage id="glossary" />
        </Link>
         <Link to={`/${currentLangKey}/topics`} className={`btn btn-link`}>
          <FormattedMessage id="topics" />
        </Link>
        <Link to={langToSelect.link} className={`btn btn-primary`}>
          <FormattedMessage id={langToSelect.langKey} />
        </Link>
      </div>
    </header>
  );
}

export default Header;
